import * as React from 'react';
import { useState, useEffect } from 'react';
import customerService from '../services/Customer';

const CustomerContext = React.createContext();

function CustomerProvider({ children, ...props }) {
      const [customerList, setCustomerList] = useState(() => props.customers || []);
      const [currentCustomer, setCurrentCustomer] = useState(() => props.defaultCustomer || null);
          useEffect(() => {
                setCustomerList(props.customers || []);
              }, [props.customers]);
          useEffect(() => {
                if (!currentCustomer && customerList.length) {
                      const stored = customerService.storedSelectedCustomer();
                      const exists = (c) =>
                            c?.id &&
                            (customerList.some(x => x.id === c.id) ||
                                 customerList.some(x => (x.children || []).some(y => y.id === c.id)));
                      setCurrentCustomer(exists(stored) ? stored : customerList[0]);
                    }
              }, [customerList, currentCustomer]);

    const fetchCustomers = React.useCallback(async () => {
        const res = await customerService.fetchCustomers();
        setCustomerList(res);
        return res;
    }, []);

    return (
        <CustomerContext.Provider value={{
            customerList,
            currentCustomer,
            setCurrentCustomer,
            fetchCustomers,
            setCustomerList,
        }}>
            {children}
        </CustomerContext.Provider>
    );
}
function useCustomers() {
    const context = React.useContext(CustomerContext);
    if (context === undefined) {
        throw new Error('useCustomers must be used within a CustomerProvider');
    }

    return context;
}

export { CustomerProvider, useCustomers }